import React from "react";

const FilterButton = ({ title, selected, setValue, value }) => {
  return (
    <div
      onClick={() => setValue(value)}
       className={`${
        value === selected
          ? "transaction-filter-button-selected"
          : "transaction-filter-button-default"
      } h-9 md:px-4 py-2 cursor-pointer  rounded-full border border-primary-600 justify-center items-center gap-2.5 inline-flex transition-all duration-500 ease-in-out`}
    >
      <p className="transaction-filter-button-title">
        {title}
      </p>
    </div>
  );
};

export default FilterButton;
